export default "__VITE_ASSET__Cowd_R5W__"